export default __webpack_public_path__ + "static/media/Rule15.6eebe090.png";